import React from 'react';

const UsagePolicy = () => {
  return (
    <div className="col-md-12 politicas">
      <h6>POLÍTICA DE USO E RESPONSABILIDADE DE CONTEÚDO</h6>
      <p>
        1) Este Boletim Informativo não substitui a publicação oficial. Seu objetivo é informar
        avisos de editais e outros dados relativos ao processo de licitações de todo País, que foram
        inseridos em nosso banco de dados.
      </p>
      <p>
        2) Os serviços de informações prestados se constituem em obrigações de meios, independendo
        do resultado dos certames.
      </p>
      <p>
        3) A exclusividade de uso é restrita para o cliente identificado no cadastro de empresas do
        ConLicitação, a quem está; direcionado o presente, sendo portanto vedado ao usuário
        distribuir, transmitir, exibir, reproduzir, transferir ou vender quaisquer informações do
        presente Boletim Informativo a terceiros.
      </p>
      <p className="float-right">
        <a href="mailto:apoio@conlicitacao.com.br">apoio@conlicitacao.com.br</a>
      </p>
    </div>
  );
};

export default UsagePolicy;
